import BaseAPI, { querySuffix } from "./BaseAPI";
import { searchRoute } from "../routes";

export default class SearchAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, searchRoute, "search");
    }

    async List(params = {}, options = {}) {
        return this._request("get", this._url(querySuffix(params)), null, options);
    }
}
